import theme from '../../../../../lib/theme';

const { layouts, scale } = theme;

export default () => ({
  panel: {
    ...layouts.panel,

    maxWidth: '100vw',
    overflow: 'hidden',
    position: 'relative',
  },

  container: {
    ...layouts.spacedColumn('m'),

    alignItems: 'flex-start',
  },

  sponsors: {
    ...layouts.container('l'),
    ...layouts.row,

    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: scale.m,
  },
});
